import { render, staticRenderFns } from "./PecaFornecedorUserForm.vue?vue&type=template&id=58a6f4c5"
import script from "./PecaFornecedorUserForm.vue?vue&type=script&lang=js"
export * from "./PecaFornecedorUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports